import { Pipe, PipeTransform } from '@angular/core';
//import { Common } from '../Utility/common';
import * as _moment from 'moment';

@Pipe({
  name: 'dateformat'
})
export class DateformatPipe implements PipeTransform {

  transform(value: any, args?: any,utc:boolean=false): any {
    var b = new Date(value); var fdate;

    if(utc){//"YYYY-MM-DD HH:mm:ss a"
      
    if(args=="daytime"){ 
      fdate =_moment.utc(value).local().format("DD MMM YYYY hh:mm A");
    }
    else if(args=="daytime2"){ 
      //  / fdate =Common._moment.utc(value).local().format("DD MMM YYYY hh:mm A");
      value=Number(value);
        fdate =_moment.utc(value).local().format('LL')
        if( _moment().format('LL') ==fdate){
          fdate =_moment(new Date(value)).format("hh:mm A");
        }else{
          fdate =_moment.utc(value).local().format("DD MMM YYYY");
        }
      }
    else if(args=="daytime1"){ 
    //  / fdate =Common._moment.utc(value).local().format("DD MMM YYYY hh:mm A");
    value=Number(value);
      fdate =_moment.utc(value).local().format('LL')
      if( _moment().format('LL') ==fdate){
        fdate =_moment(new Date(value)).format("hh:mm A");
      }else{
        fdate =_moment.utc(value).local().format("DD MMM YYYY hh:mm A");
      }
    }
    else if(args=="timestamp"){
     // fdate =Common._moment(value).format("DD MMM YYYY hh:mm A");
     fdate =_moment(new Date(value)).format("hh:mm A");
    }
    return fdate;
  }else {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      var d = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      };
      fdate = b.toLocaleDateString("en-US") + " " + b.toLocaleTimeString("en-US").replace(/[^ -~]/g, "").replace(/IST/g, "")
    } else {
      let d :any = {
        year: "long",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      };
      
      fdate = b.toLocaleDateString("en-US", d).replace(/[^ -~]/g, "")
    }

  }  

    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var output="";
    if(args=="date"){
      var b = new Date(fdate.trim());
      "object" != typeof Date && (b = new Date(b));
      var c = b.getMonth(),
        d1 = b.getFullYear(),
        e = b.getDate();
        output= e + " " + monthNames[c] + " " + d1 + ""
    }
    if(args=="daydate"){
      var b = new Date(fdate.trim());
        "object" != typeof Date && (b = new Date(b));
          // Calculate time between two dates:
          const date1:any = b; // the date you already commented/ posted
          const date2: any = new Date(); // today
          let r = {}; // object for clarity
          let message: string="";

          const diffInSeconds = Math.abs(date2 - date1) / 1000;
          const days = Math.floor(diffInSeconds / 60 / 60 / 24);
          const hours = Math.floor(diffInSeconds / 60 / 60 % 24);
          const minutes = Math.floor(diffInSeconds / 60 % 60);
          const seconds = Math.floor(diffInSeconds % 60);
          const milliseconds = 
         Math.round((diffInSeconds - Math.floor(diffInSeconds)) * 1000);

          const months = Math.floor(days / 31);
          const years = Math.floor(months / 12);

          // the below object is just optional 
          // if you want to return an object instead of a message
          r = {
              years: years,
              months: months,
              days: days,
              hours: hours,
              minutes: minutes,
              seconds: seconds,
              milliseconds: milliseconds
          };

          // check if difference is in years or months
          if (years === 0 && months === 0) {
              // show in days if no years / months
              if (days > 0) {
                
                  if (days === 1) {
                      message =  'Yesterday';
                  } else { message = days + ' days ago'; }
              }  else if (hours > 0) {
                  if (hours === 1) {
                      message = hours + ' hour ago';
                  } else {
                      message = hours + ' hours ago';
                  }
              } else if (minutes > 0) {
                  // show in minutes if no years / months / days
                  if (minutes === 1) {
                      message = minutes + ' minute ago';
                  } else {message = minutes + ' minutes ago';}  
              }
              else{
                if (seconds === 1) {
                  message = seconds + ' second ago';
                } else {message = seconds + ' seconds ago';}  
              }
          } else if (years === 0 && months > 0) {
            message= b.getDate() + " " + monthNames[b.getMonth()] + " " + b.getFullYear() ;
              // show in months if no years
             /* if (months === 1) {
                  message = months + ' month';
              } else {message = months + ' months';}*/
          } else if (years > 0) {
            message= b.getDate() + " " + monthNames[b.getMonth()] + " " + b.getFullYear() ;
              // show in years if years exist
             /* if (years === 1) {
                  message = years + ' year';
              } else {message = years + ' years';}*/
          }
          output =   message ; 
    }
    if(args=="daytime"){
      var c1 = new Date(fdate.trim()),
            d1 = c1.getMonth(),
            e = c1.getFullYear(),
            f1 = c1.getDate(),
            g = c1.getHours(),
            h = c1.getMinutes(),
            i = g >= 12 ? "PM" : "AM", h1 = h < 10 ? "0" + h : h,g2= g %= 12, g = g || 12;
            output =  f1 + " " + monthNames[d1] + " " + e + " " + g2 + ":" + h1 + " " + i
    }
    if(args=="time"){
      var c1 = new Date(fdate.trim()),
            d1 = c1.getMonth(),
            e = c1.getFullYear(),
            f1 = c1.getDate(),
            g = c1.getHours(),
            h = c1.getMinutes(),
            i = g >= 12 ? "PM" : "AM", h1 = h < 10 ? "0" + h : h,g2= g %= 12, g = g || 12;
            output =   g2 + ":" + h1 + " " + i
    }

    if(args=="tspantotime"){
          let message: string;

          const diffInSeconds =value;// Math.abs(date2 - date1) / 1000;
          const days = Math.floor(diffInSeconds / 60 / 60 / 24);
          const hours = Math.floor(diffInSeconds / 60 / 60 % 24);
          const minutes = Math.floor(diffInSeconds / 60 % 60);
          const seconds = Math.floor(diffInSeconds % 60);
          const milliseconds = 
         Math.round((diffInSeconds - Math.floor(diffInSeconds)) * 1000);

          const months = Math.floor(days / 31);
          const years = Math.floor(months / 12);


          message="";
            // show in days if no years / months
            if (days && days>0) {
               message = days + ' days, '; 
            }  
            
            if (hours && hours > 0) {
                if (hours === 1) {
                    message += hours + ' hour, ';
                } else {
                    message += hours + ' hours, ';
                }
            } 
            
            if (minutes && minutes > 0) {
                // show in minutes if no years / months / days
                if (minutes === 1) {
                    message += minutes + ' minute, ';
                } else {message += minutes + ' minutes, ';}  
            }

            if (seconds === 1) {
              message += seconds + ' second ';
            } else {message += seconds + ' seconds ';}  


          output =   message ; 
    }
  
    return output;
  }
}
